import PricePointComponent from './price_point.component';

let PricePointModule = angular.module('pricepoint', [
])

  .component('pricepoint', PricePointComponent)

  .name;

export default PricePointModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/price_point/index.js